<template>
    <div class="container" style="height:200px;overflow:hidden;">
        
            <img :src="$root.urlsite+'documenti/backInside.png'" style="margin: 0;"/>
       
    </div>
</template>

<script>

export default {
  name: 'site-header',
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// Image-inside.vue?3ce454ee